export default __webpack_public_path__ + "static/media/pakistan.3cf42a85.svg";